import { Controller, Payload } from "../../../controller";
import { ApplicationState } from "../../../store";
import { bindActionCreators, Dispatch } from "redux";

import { ConvenioActions, Convenio, ConvenioState,initialValueConvenioState } from "./convenio.model"

export interface ConvenioViewProps{
    convenioState:ConvenioState
    convenioActions:ConvenioActions
}


class ConvenioController extends Controller<Convenio, ConvenioState, ConvenioActions> {
    constructor() {
        super(initialValueConvenioState.row.type, initialValueConvenioState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
        ]
    }

    private* novoActionEffects(actions:Payload){

    }
}

export const convenioController = new ConvenioController()

export const mapStateToConvenioProps = (state: ApplicationState) => ({
    convenioState: state.convenioState,
})

export const mapDispatchToConvenioProps = (dispatch: Dispatch) => ({
    convenioActions: bindActionCreators({...convenioController.reducer.actions}, dispatch),
})